import { render, staticRenderFns } from "./FndPermissionQuery.vue?vue&type=template&id=d6b3ee96&"
import script from "./FndPermissionQuery.vue?vue&type=script&lang=js&"
export * from "./FndPermissionQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports